import { useEffect, useRef } from "react"
import { DigitalWaiver } from "../components/additionalInfo/DigitalWaiver/DigitalWaiver"
import { Questions } from "../components/additionalInfo/Questions/Questions"
// import { CancellationPolicy } from "../components/additionalInfo/CancellationPolicy/CancellationPolicy"
import { AddOns } from "../components/additionalInfo/AddOns/AddOns"
import { useWizardContext } from "../WizardContext"
import { buildAdditionalInfoPayload, isServerId } from "../mappers/toApiPayload"

export const AdditionalInfoStep = () => {
  const { form, stepSaveHandlersRef } = useWizardContext()
  // Capture server-assigned IDs on mount so deleted add-ons can be sent with _destroy: true
  const initialServerAddOnIdsRef = useRef(null)

  useEffect(() => {
    const addOns = form.getFieldValue("add_ons") || []
    initialServerAddOnIdsRef.current = addOns.filter((a) => isServerId(a.id)).map((a) => a.id)
  }, [form])

  useEffect(() => {
    stepSaveHandlersRef.current["additional_info"] = () => {
      const addOns = form.getFieldValue("add_ons") || []
      const digitalWaiverIds = form.getFieldValue("digital_waiver") || []
      const questionTemplateIds = form.getFieldValue("question_template") || []
      return buildAdditionalInfoPayload(addOns, initialServerAddOnIdsRef.current || [], digitalWaiverIds, questionTemplateIds)
    }
    return () => {
      delete stepSaveHandlersRef.current["additional_info"]
    }
  }, [form, stepSaveHandlersRef])

  return (
    <div>
      <DigitalWaiver />
      <Questions />
      {/* <CancellationPolicy /> */}
      <AddOns />
    </div>
  )
}
